import { HTMLAttributes } from 'react';

import cn from 'classnames';

function Spinner({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn('au-spinner au-w-c112', className)} {...props}>
      <svg className="au-spinner__background" viewBox="22 22 44 44">
        <circle cx="44" cy="44" r="20.2" fill="none" strokeWidth="2" />
      </svg>
      <svg className="au-spinner__foreground" viewBox="22 22 44 44">
        <circle cx="44" cy="44" r="20.2" fill="none" strokeWidth="2" />
      </svg>
    </div>
  );
}

export default Spinner;
